(function () {
  "use strict";

  angular
    .module('trainerWebApp.resources')
    .factory('excelResource', ['$resource', 'errorHandler', function ($resource, errorHandler) {
      var ExcelResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/parsed-spreadsheet');

      ExcelResource.prototype.getExcelData = function getExcelData(fileUrl, resultCb, errorCb) {
        return ExcelResource.save({ fileUrl: fileUrl }, resultCb || angular.noop,
          errorHandler.defaultServerErrorHandler(errorCb));
      };

      return new ExcelResource();
    }]
  );
})();
